<template>
  <div class="payment-container">
    <h1 class="amount">{{ invoice.amount.toFixed(2) }} AED</h1>
    <p class="desc">{{ invoice.description || "No description" }}</p>
    <div class="status" v-if="invoice.status === 'paid'">
      <div class="checkmark">&#10003;</div>
      <p class="paid">Payment received</p>
    </div>
    <div class="methods" v-else>
      <button @click="payWithCard">Pay with Card / Apple Pay</button>
      <button @click="showTON">Pay with TON</button>
      <button @click="downloadPDF">Bank Transfer (PDF)</button>
    </div>
    <div v-if="tonVisible" class="ton-info">
      <p>
        <b>TON Address:</b><br /><code>{{ invoice.ton_address }}</code>
      </p>
      <p>
        <b>Comment:</b><br /><code>{{ invoice.ton_comment }}</code>
      </p>
      <button class="confirm" @click="markAsPaid('ton')">Payment Sent</button>
    </div>
  </div>
</template>

<script>
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(
  "pk_test_51PH06OCfrXsyM2MOz665Mb6sgEnnnjetZUrhpGfFRRguWWcWozCmV3FzBA3q07e102PrLvSxH5eFhWfmn3bmP2m800sEKrc90z"
); // ⬅️ ВСТАВЬ свой публичный ключ Stripe

export default {
  name: "PayView",
  data() {
    return {
      invoice: {
        id: 92812,
        amount: 129.0,
        description: "Cleaning services",
        status: "pending",
        ton_address: "UQAfY...TONADDR",
        ton_comment: "INV_92812.abcdef",
      },
      tonVisible: false,
    };
  },
  methods: {
    async payWithCard() {
      const stripe = await stripePromise;

      const res = await fetch("/api/create-checkout-session", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount: this.invoice.amount,
          description: this.invoice.description,
        }),
      });

      const session = await res.json();

      if (session.id) {
        const { error } = await stripe.redirectToCheckout({
          sessionId: session.id,
        });
        if (error) console.error(error);
      } else {
        alert("Ошибка создания сессии Stripe");
        console.error(session);
      }
    },
    showTON() {
      this.tonVisible = !this.tonVisible;
    },
    downloadPDF() {
      window.open(`/invoice/${this.invoice.id}/pdf`, "_blank");
    },
    markAsPaid(method) {
      fetch("/api/payment-attempt", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          invoice_id: this.invoice.id,
          method: method,
        }),
      }).then(() => alert("Marked as paid. Awaiting confirmation."));
    },
  },
};
</script>

<style scoped>
.payment-container {
  max-width: 420px;
  margin: auto;
  text-align: center;
  padding: 2em;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.amount {
  font-size: 3em;
  margin-bottom: 0.2em;
}
.desc {
  color: #555;
  margin-bottom: 1.5em;
}
.methods button,
.confirm {
  display: block;
  width: 100%;
  padding: 0.9em;
  margin: 0.5em 0;
  border: none;
  background: #000;
  color: #fff;
  font-size: 1em;
  border-radius: 8px;
}
.ton-info {
  margin-top: 1em;
  text-align: left;
}
.ton-info code {
  display: block;
  background: #f4f4f4;
  padding: 0.5em;
  margin: 0.5em 0;
}
.status {
  background: #dff0d8;
  border: 2px solid #3c763d;
  border-radius: 8px;
  padding: 1.2em;
}
.checkmark {
  font-size: 2.5em;
  color: #3c763d;
}
.paid {
  font-weight: bold;
  color: #3c763d;
  margin-top: 0.5em;
}
</style>
